import { ScriptDef, ScriptTheme } from '../../types';

export const MOVIE_DONGZUO_SCRIPTS: ScriptDef[] = [
    {
        id: 'SCRIPT_095',
        name: '过闸',
        genre: 'movie',
        synopsis: '明末运河枯水，漕船全堵在淮安大闸外。户部小官温伯琰身怀记满亏空的漕运底册，东厂档头阚追奉旨截册，船家女柴银瓶的货船夹在中间，镖师霍平暗护底册。闸门三起三落，过闸那天，柴银瓶把三拨人的货单一起扔进水里，漂开的竟是同一家的货。',
        roles: [
            {
                name: '柴银瓶',
                roleType: '女主角',
                billing: 1,
                intro: '漕船船娘，三条船的当家人，杀过水匪埋过伙计，账本没漏过一笔。三拨客人的货单她全收着。',
                level: 8,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 80 },
                    { attr: 'stamina', value: 70 },
                    { attr: 'temperament', value: 65 },
                    { attr: 'wisdom', value: 55 },
                ],
                shootWeeks: 5,
                attributeGrowth: { talent: 4, stamina: 3, temperament: 3, wisdom: 3 },
            },
            {
                name: '温伯琰',
                roleType: '男主角',
                billing: 1,
                intro: '户部主事，携底册南下的"翻账人"，手无缚鸡之力，字写得比刀快。投船时化名全被她识破。',
                level: 8,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 80 },
                    { attr: 'wisdom', value: 70 },
                    { attr: 'temperament', value: 65 },
                    { attr: 'charm', value: 55 },
                ],
                shootWeeks: 5,
                attributeGrowth: { talent: 4, wisdom: 3, temperament: 3, charm: 3 },
            },
            {
                name: '霍平',
                roleType: '男配角',
                billing: 3,
                intro: '镖师，锦衣卫卫所出身，吃空饷吃怕了脱的籍。祖传的刀多年没开刃，师父遗训"刃开必有账"。',
                level: 6,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 50 },
                    { attr: 'stamina', value: 45 },
                    { attr: 'temperament', value: 40 },
                ],
                shootWeeks: 3,
                attributeGrowth: { talent: 3, stamina: 3, temperament: 2 },
            },
            {
                name: '连翘',
                roleType: '女配角',
                billing: 4,
                intro: '东厂女档头，阚追的副手，使一双短匕。上船从不落座，只靠着船舷数人，数完在心里给每人排了座次。',
                level: 5,
                gender: 'female',
                requirements: [
                    { attr: 'stamina', value: 40 },
                    { attr: 'talent', value: 35 },
                    { attr: 'temperament', value: 30 },
                ],
                shootWeeks: 2,
                attributeGrowth: { stamina: 2, talent: 2, temperament: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.MartialArts, ScriptTheme.Ancient],
        heat: 57,
        baseScore: 8.6,
    },
    {
        id: 'SCRIPT_096',
        name: '拆手',
        genre: 'movie',
        synopsis: '民国卫城武行规矩：徒弟出师须当面赢师父半招。码头出身的郁承志出师擂上连赢师父程铁桥三阵，武行前辈却看出第三阵是师父让了艺。拳馆被封，郁承志上书请求重开公议，对手填的不是师父，是督军府武术教官洪铁山——赢了教官，才配当众跟师父重拆那半招。',
        roles: [
            {
                name: '郁承志',
                roleType: '男二号',
                billing: 2,
                intro: '码头出身的徒弟，扛包扛出肩上的茧。赢了师父三阵，干净得自己心里发虚。',
                level: 6,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 50 },
                    { attr: 'stamina', value: 45 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 4,
                attributeGrowth: { talent: 3, stamina: 3, charm: 2 },
            },
            {
                name: '程露',
                roleType: '女配角',
                billing: 4,
                intro: '程铁桥的独女，武馆最小的徒弟。师兄出师那天，她守在擂台边看懂了第三阵的让，把话咽回了肚子里。',
                level: 5,
                gender: 'female',
                requirements: [
                    { attr: 'stamina', value: 40 },
                    { attr: 'talent', value: 35 },
                    { attr: 'charm', value: 30 },
                ],
                shootWeeks: 2,
                attributeGrowth: { stamina: 2, talent: 2, charm: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.MartialArts, ScriptTheme.Period],
        heat: 45,
        baseScore: 8.3,
    },
    {
        id: 'SCRIPT_097',
        name: '镖不喊沧',
        genre: 'movie',
        synopsis: '光绪年间火车通到直隶，镖行生意一年薄过一年。沧州窦家走最后一趟镖，沿途照旧喊镖号，唯独过沧州不能喊，这是武行百年的老礼。少镖头窦青笠想破例一喊被父亲鞭阻，地头武魁庞震设茶棚拦路切磋。铁轨铺过茶棚那天，镖旗改成了货签。',
        roles: [
            {
                name: '窦青笠',
                roleType: '女主角',
                billing: 1,
                intro: '少镖头，镖旗号衣是她娘留下的，穿着大一号。练嗓练到能喊穿一条街，最后喊给了铁轨。',
                level: 7,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'stamina', value: 55 },
                    { attr: 'charm', value: 50 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 5,
                attributeGrowth: { talent: 3, stamina: 3, charm: 2, wisdom: 2 },
            },
            {
                name: '冯克俭',
                roleType: '男配角',
                billing: 3,
                intro: '铁路工程师，洋学生出身。给镖队算过一笔账，算完把纸折起来塞回了袖子。',
                level: 5,
                gender: 'male',
                requirements: [
                    { attr: 'temperament', value: 40 },
                    { attr: 'talent', value: 35 },
                    { attr: 'wisdom', value: 30 },
                ],
                shootWeeks: 3,
                attributeGrowth: { temperament: 2, talent: 2, wisdom: 2 },
            },
            {
                name: '苗小槐',
                roleType: '女配角',
                billing: 4,
                intro: '窦家镖队的女趟子手，管骡马也管旗。过沧州那夜她守着镖旗没敢睡，第二天嗓子哑了。',
                level: 4,
                gender: 'female',
                requirements: [
                    { attr: 'stamina', value: 30 },
                    { attr: 'temperament', value: 25 },
                ],
                shootWeeks: 2,
                attributeGrowth: { stamina: 3, temperament: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.MartialArts, ScriptTheme.Period],
        heat: 44,
        baseScore: 8.2,
    },
    {
        id: 'SCRIPT_098',
        name: '走镖',
        genre: 'movie',
        synopsis: '民国初年官道改线，镖局歇业前接了最后一单：女镖师仇九娘与老镖师聂远桥护送东家的一车旧账册走老路进山。老路上等着他们的，是当年吃过这趟镖亏、如今落了草的旧镖师，领头的正是教过她走镖的师父。第一刀砍不砍得下去，全看这条老路上的规矩还剩几分。',
        roles: [
            {
                name: '仇九娘',
                roleType: '女主角',
                billing: 1,
                intro: '女镖师，镖局唯一的传人，双刀是父亲改小的。每条老路的口子她都背得下来，没走过回程。',
                level: 7,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'stamina', value: 55 },
                    { attr: 'temperament', value: 50 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 5,
                attributeGrowth: { talent: 3, stamina: 3, temperament: 2, wisdom: 2 },
            },
            {
                name: '明重九',
                roleType: '男配角',
                billing: 3,
                intro: '商号东家，押的不是货，是他爹留下的旧账册。一路只问镖师一句话：镖丢了，人赔还是命赔。',
                level: 5,
                gender: 'male',
                requirements: [
                    { attr: 'temperament', value: 40 },
                    { attr: 'talent', value: 35 },
                    { attr: 'wisdom', value: 30 },
                ],
                shootWeeks: 3,
                attributeGrowth: { temperament: 2, talent: 2, wisdom: 2 },
            },
            {
                name: '遂安',
                roleType: '男配角',
                billing: 3,
                intro: '账房，第一次出远门，晕车晕马，账本抱着不撒手，到了地方还在数铜板。',
                level: 4,
                gender: 'male',
                requirements: [
                    { attr: 'temperament', value: 30 },
                    { attr: 'talent', value: 25 },
                ],
                shootWeeks: 3,
                attributeGrowth: { temperament: 3, talent: 2 },
            },
            {
                name: '柳莺枝',
                roleType: '女配角',
                billing: 4,
                intro: '东家明重九的独女，旧账册里夹着她娘的嫁妆单。跟着镖队进山，是要当面问落草的旧镖师一句旧话。',
                level: 5,
                gender: 'female',
                requirements: [
                    { attr: 'temperament', value: 40 },
                    { attr: 'talent', value: 35 },
                    { attr: 'wisdom', value: 30 },
                ],
                shootWeeks: 2,
                attributeGrowth: { temperament: 2, talent: 2, wisdom: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.MartialArts, ScriptTheme.Period],
        heat: 39,
        baseScore: 7.2,
    },
    {
        id: 'SCRIPT_099',
        name: '剑冢',
        genre: 'movie',
        synopsis: '神剑山庄少主宫无极十二岁败尽庄内剑客，被尊为"剑神"。魔教教主燕十煞为夺《剑冢图》血洗三大门派，师妹花想容为护他身中剧毒。宫无极闭关十年出山，一路以一敌百，最终在剑冢与燕十煞决战，击败魔教、救回师妹。',
        roles: [
            {
                name: '宫无极',
                roleType: '男主角',
                billing: 1,
                intro: '神剑山庄少主，十二岁起庄内无人能接他一招。闭关十年只精研一式剑招，出山后以此一招破尽各路对手。',
                level: 6,
                gender: 'male',
                requirements: [
                    { attr: 'charm', value: 50 },
                    { attr: 'stamina', value: 45 },
                    { attr: 'temperament', value: 40 },
                ],
                shootWeeks: 5,
                attributeGrowth: { charm: 3, stamina: 3, temperament: 2 },
            },
            {
                name: '花想容',
                roleType: '女配角',
                billing: 2,
                intro: '师妹，与宫无极青梅竹马。先后经历中毒与被劫，每次脱险都依赖宫无极及时赶到，是推动主角行动的主要情感动因。',
                level: 4,
                gender: 'female',
                requirements: [
                    { attr: 'charm', value: 30 },
                    { attr: 'temperament', value: 25 },
                ],
                shootWeeks: 4,
                attributeGrowth: { charm: 3, temperament: 2 },
            },
            {
                name: '白若素',
                roleType: '女配角',
                billing: 3,
                intro: '魔教护法，燕十煞麾下唯一的女高手，使九节鞭。血洗三大门派那晚，她的鞭子独独没落向女眷。',
                level: 4,
                gender: 'female',
                requirements: [
                    { attr: 'temperament', value: 30 },
                    { attr: 'stamina', value: 25 },
                ],
                shootWeeks: 3,
                attributeGrowth: { temperament: 3, stamina: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.MartialArts, ScriptTheme.Fantasy],
        heat: 29,
        baseScore: 4.8,
    },
    {
        id: 'SCRIPT_125',
        name: '司天监',
        genre: 'movie',
        synopsis: '新帝登基前百日，观星台连报"荧惑守心"，城中接连三起天火。下狱七年的前司天监丞裴衡之被特赦查案，当年因同一凶象获罪自尽的监正，正是他的父亲。他与机关师宣卷验遍火场，落点连成一张废弃的宫城布防图，而父亲的旧手稿里，早记过这场天象。',
        roles: [
            {
                name: '宣卷',
                roleType: '女主角',
                billing: 1,
                intro: '将作监机关师之女，承了家传的图纸辨识术。三处火场的灰烬筛了三遍，筛出的是一套图纸上才有的暗渠。',
                level: 7,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'wisdom', value: 55 },
                    { attr: 'temperament', value: 50 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 5,
                attributeGrowth: { talent: 3, wisdom: 3, temperament: 2, charm: 2 },
            },
            {
                name: '甘九安',
                roleType: '男配角',
                billing: 3,
                intro: '金吾卫旅帅，负责火场封禁，封禁令是他签的。私下给裴衡之留了一条走地渠的路，自己在渠口守着。',
                level: 5,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 40 },
                    { attr: 'stamina', value: 35 },
                    { attr: 'temperament', value: 30 },
                ],
                shootWeeks: 3,
                attributeGrowth: { talent: 2, stamina: 2, temperament: 2 },
            },
            {
                name: '窦星奴',
                roleType: '女配角',
                billing: 3,
                intro: '观星台的司晨女官，掌漏刻报时。三起天火的时间点都由她报出，她比谁都清楚哪一炷香烧得快了。',
                level: 5,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 40 },
                    { attr: 'wisdom', value: 35 },
                    { attr: 'temperament', value: 30 },
                ],
                shootWeeks: 3,
                attributeGrowth: { talent: 2, wisdom: 2, temperament: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Ancient, ScriptTheme.Mystery, ScriptTheme.Fantasy],
        heat: 47,
        baseScore: 6.9,
    },
    {
        id: 'SCRIPT_126',
        name: '潜渊',
        genre: 'movie',
        synopsis: '南海海沟四千米深处，打捞队找到了一艘载有稀土原矿的沉船。下潜第九天，机械臂抓上来的铭牌出厂日期竟是下个月，氧气只够四天，声呐屏上又多出一个金属回波。打捞队长贺沉舟与工程师薛汐必须决定：继续捞，还是带所有人回家。',
        roles: [
            {
                name: '薛汐',
                roleType: '女主角',
                billing: 1,
                intro: '深潜器材料工程师，造的耐压壳比标准厚，超支的预算自己凑。全船唯一反对打捞的人，活干得最细。',
                level: 7,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'wisdom', value: 55 },
                    { attr: 'temperament', value: 50 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 5,
                attributeGrowth: { talent: 3, wisdom: 3, temperament: 2, charm: 2 },
            },
            {
                name: '苗拓海',
                roleType: '男二号',
                billing: 2,
                intro: '船东公司代表，押着打捞进度，报酬与稀土回收率挂钩。卫星电话每天准点响，后来有一通没接。',
                level: 6,
                gender: 'male',
                requirements: [
                    { attr: 'temperament', value: 50 },
                    { attr: 'talent', value: 45 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 4,
                attributeGrowth: { temperament: 3, talent: 3, wisdom: 2 },
            },
            {
                name: '阿肥',
                roleType: '男配角',
                billing: 5,
                intro: '母船水手，头一回出远海，把值班表背得比谁都熟，点名时他应得最响。',
                level: 3,
                gender: 'male',
                requirements: [
                    { attr: 'stamina', value: 18 },
                    { attr: 'temperament', value: 15 },
                ],
                shootWeeks: 1,
                attributeGrowth: { stamina: 2, temperament: 2 },
            },
            {
                name: '顾若寒',
                roleType: '女配角',
                billing: 3,
                intro: '打捞队的女潜水员，下潜次数全队第二。她给每个新人都写过一封下水前该知道的事，阿肥那封还揣在兜里。',
                level: 5,
                gender: 'female',
                requirements: [
                    { attr: 'stamina', value: 40 },
                    { attr: 'talent', value: 35 },
                    { attr: 'temperament', value: 30 },
                ],
                shootWeeks: 3,
                attributeGrowth: { stamina: 2, talent: 2, temperament: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Action, ScriptTheme.Disaster, ScriptTheme.Mystery],
        heat: 42,
        baseScore: 6.6,
    },
    {
        id: 'SCRIPT_128',
        name: '地宫',
        genre: 'movie',
        synopsis: '上古神物封于地宫，世代由守宫人看管。盗墓团伙闯入，触发封印，神物破封而出。守宫人祝九歌必须在重新封印与释放神物之间做出选择——她知道封印的代价，却不知道师姐祝九弦十年前为何离开地宫。',
        roles: [
            {
                name: '祝九歌',
                roleType: '女主角',
                billing: 1,
                intro: '巫祝，世代守护地宫，掌握全部机关布局。她知道哪些机关能困住神物，哪些是用来保护自己的。',
                level: 8,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 80 },
                    { attr: 'wisdom', value: 70 },
                    { attr: 'temperament', value: 65 },
                    { attr: 'stamina', value: 55 },
                ],
                shootWeeks: 5,
                attributeGrowth: { talent: 4, wisdom: 3, temperament: 3, stamina: 3 },
            },
            {
                name: '裴铮',
                roleType: '男配角',
                billing: 2,
                intro: '盗墓团伙首领，受雇取宝。对地宫的凶险一无所知，只看到价值，没看到代价。',
                level: 6,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 50 },
                    { attr: 'temperament', value: 45 },
                    { attr: 'stamina', value: 40 },
                ],
                shootWeeks: 4,
                attributeGrowth: { talent: 3, temperament: 3, stamina: 2 },
            },
            {
                name: '苏棠',
                roleType: '女配角',
                billing: 3,
                intro: '考古研究员，随队考察地宫结构。队伍里唯一相信巫祝说法的人，她的田野笔记记下了地宫最深的一条路线——无人走出的路。',
                level: 5,
                gender: 'female',
                requirements: [
                    { attr: 'temperament', value: 40 },
                    { attr: 'talent', value: 35 },
                    { attr: 'wisdom', value: 30 },
                ],
                shootWeeks: 3,
                attributeGrowth: { temperament: 2, talent: 2, wisdom: 2 },
            },
            {
                name: '祝九弦',
                roleType: '女配角',
                billing: 4,
                intro: '祝九歌的师姐，十年前离开地宫后下落不明，如今出现在盗墓队伍里。她说找到了破解封印的方法，代价是牺牲一个人。',
                level: 4,
                gender: 'female',
                requirements: [
                    { attr: 'temperament', value: 30 },
                    { attr: 'talent', value: 25 },
                ],
                shootWeeks: 2,
                attributeGrowth: { temperament: 3, talent: 2 },
            },
            {
                name: '阿维',
                roleType: '男配角',
                billing: 5,
                intro: '盗墓团伙的杂役，负责搬运器材。进地宫前他把家人的地址写在手背上，进去后再没看过一眼。',
                level: 3,
                gender: 'male',
                requirements: [
                    { attr: 'temperament', value: 18 },
                    { attr: 'stamina', value: 15 },
                ],
                shootWeeks: 1,
                attributeGrowth: { temperament: 2, stamina: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Action, ScriptTheme.Mystery, ScriptTheme.Fantasy],
        heat: 49,
        baseScore: 7.6,
    },
];
